import { registerBlock } from '../../core/registry.js';
import { TextCanvas, TextInspector } from './Canvas.jsx';

const definition = {
  type: 'text',
  schema: {
    defaults: () => ({ html: '', className: '' }),
  },
  capabilities: {
    isContainer: false,
  },
  ui: {
    Canvas: TextCanvas,
    Inspector: TextInspector,
    icon: '📝',
    label: 'Text',
    keywords: ['paragraph', 'rich text', 'body'],
  },
  serialize: (attrs) => {
    const html = attrs.html || '';
    const cls = attrs.className ? ` class="${attrs.className}"` : '';
    return `<div${cls}>${html}</div>`;
  },
};

registerBlock(definition);
export default definition;
